<div class="nuestra-historia mt-5 pt-5">

  <div class="titulo">
    <app-titulo-descripcion titulo={{titulo}} descripcion={{descripcion}}></app-titulo-descripcion>
  </div>

  <!--<div class="linea-temporal m-auto pt-5">

    <h2 class="subtitulo-a text-center mb-3">
      <i class="fas fa-hourglass-half icono mr-2"></i>
      <strong class="text-dark">{{subtituloA}}</strong>
    </h2>

    <div class="linea mt-5 pb-5 ">
      <app-linea-temporal></app-linea-temporal>
    </div>
  </div> -->

  <div class="dentro-hogar pt-5">

    <h2 class="subtitulo-a text-center mb-3">
      <i class="fas fa-door-open icono mr-2"></i>
      <strong class="text-dark">{{subtituloB}}</strong>
    </h2>

    <div class="row justify-content-center">
      <iframe width="{{scrWidth}}" height="{{scrHeight}}" src="https://www.youtube.com/embed/RU7XHBVfduw"
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
  </div>
</div>
